export default {"src":"/_next/static/media/usa.89d62bd7.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};